import * as React from "react";
import { Link } from 'react-router-dom';

import { AppBar, Typography, Menu, MenuItem, Snackbar } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

import './Header.scss';
import gql from "graphql-tag";
import { InMemoryCache } from 'apollo-boost';
import Query from "react-apollo/Query";
import { CachePersistor } from 'apollo-cache-persist';
import { client } from "src";
import { DashBoardModal } from "src/component/shared/layout/products/DashboardModal";
import { GoogleAnalytics } from "src/services/GoogleAnalytics";
import { Notification } from "../notification/Notification";
import { AdminUsers } from "../../admin/AdminUsers";
// import { AdminImportProducts } from "../../admin/AdminImportProducts";
import { RemoveDataFromSession } from '../../cache/Cache';
// import { AdminImportPartnerData } from "../../admin/partnerData/AdminImportPartnerData";
import { ACCESS_DASHBOARD } from "../products/Dashboard";
import { AuthContext, IAuthContextData } from "src/auth";
import { ResultadoExportacao } from "../../resultado-exportacao";

export const GET_LOGGED_USER = gql`
query user {
  user {
    email,
    full_name
  }
}
`;

const ga = new GoogleAnalytics();

export interface IHeaderProps {
  title: string,
  link?: string,
  name?: string
}

export interface IHeaderState {
  anchorEl?: HTMLElement;
  emailLogged: string;
  isAdmin: boolean;
  snackOpen: boolean;
  userNameLogged: string;
}

export class Header extends React.Component<IHeaderProps, IHeaderState> {

  constructor(props: IHeaderProps) {
    super(props);

    if (this.props.name) {
      document.title = 'Bookinfo - ' + this.props.name;
    }

    this.state = {
      anchorEl: undefined,
      emailLogged: '',
      isAdmin: false,
      snackOpen: false,
      userNameLogged: ''
    };

  }

  public componentWillMount () {
    this.userIsAdmin().then(result => {
        this.setState({
          isAdmin: result
        })
    });
  }

  public render() {
    const logo = require("../../../../assets/icons/logo.svg");
    const { anchorEl, snackOpen} = this.state;

    return (
      <div>
        <div>        
          <AppBar position="static" className="header-bar" >
            <Query query={GET_LOGGED_USER}>
              {({ loading, error, data }) => {
                if (data && data.user) {
                  this.setEmailLogged(data.user.email);
                  this.setUserNameLogged(data.user.full_name);
                  ga.fireTracking(data.user.email);
                }

                return <span/>;
              }}
            </Query>
            <Link to={this.props.link ? this.props.link : '#'} className="link-bar">
              <img src={logo} alt="Bookinfo" className="logo-bar" />
              <Typography variant="title" className="title-bar">
                {this.props.title}
              </Typography>
            </Link>

            <div className="header-buttons">
                <ResultadoExportacao />             
              {this.state.isAdmin && <AdminUsers />}

              {/* {this.state.isAdmin && <AdminImportProducts />} */}

              {/* {this.state.isAdmin && <AdminImportPartnerData />} */}

              <div className="notification-icon-bar">
                <Notification/>
              </div>
              <DashBoardModal />
              <IconButton
                aria-owns={anchorEl ? 'menu-bar' : undefined}
                aria-haspopup="true"
                onClick={this.handleClick}
                color="inherit"
                aria-label="Menu"
                className="menu-icon-bar"
              >
                <MenuIcon />
              </IconButton>
            </div>
            <AuthContext.Consumer>      
              {(value: IAuthContextData) => (
            <Menu
                id="menu-bar"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={this.handleClose}
              >
                <MenuItem className="menu-item-bar" onClick={this.updateDate}>Atualizar Dados</MenuItem>
                <MenuItem className="menu-item-bar" onClick={() => this.logout(value)}>Sair</MenuItem>
              </Menu>
              )}
             </AuthContext.Consumer>

            <Snackbar
              anchorOrigin={{
                horizontal: 'right',
                vertical: 'bottom',
              }}
              open={snackOpen}
              autoHideDuration={3000}
              onClose={this.handleSnackClose}
              className="snackSuccess"
              message={<span id="message-id">Os dados estão sendo atualizados.</span>}
              action={[
                <IconButton
                  key="close"
                  aria-label="Close"
                  color="inherit"
                  onClick={this.handleSnackClose}
                >
                  <CloseIcon />
                </IconButton>,
              ]}
            />

          </AppBar> 
         
        </div> 
      </div>
    );
  }

  private setEmailLogged(emailLogged: string) {
    if (emailLogged !== this.state.emailLogged) {
      this.setState({ emailLogged })
    }
  }

  private setUserNameLogged (userNameLogged: string) {
    if(userNameLogged !== this.state.userNameLogged) {
      this.setState({userNameLogged});
    }
  }

  private userIsAdmin = () => {

    return client.query({
      query: ACCESS_DASHBOARD,
      variables: {}
    }).then((result:any) => {
        return result.data && result.data.dashBoard && result.data.dashBoard.array_profiles && result.data.dashBoard.array_profiles.includes(2);
    });

  }

  private handleClick = (event: React.MouseEvent<HTMLElement>) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  private handleClose = () => {
    this.setState({ anchorEl: undefined });
  };

  private handleSnackClose = () => {
    this.setState({ snackOpen: false });
  }

  private updateDate = () => {

    this.purgeCache();
    this.clearCache();

    this.handleClose();
    this.setState({ snackOpen: true });
    window.location.reload();
  };

  private logout = (value: IAuthContextData) => {
    this.purgeCache();

    this.handleClose();

    value.Logout();
    this.clearCache();
    client.clearStore();
  };

  private purgeCache () {
    // Purge cache
    new CachePersistor({
      cache: new InMemoryCache(),
      storage: window.localStorage
    }).purge();
  }

  private clearCache () {
    RemoveDataFromSession('bookstore-data');
    RemoveDataFromSession('publisher-data');
  }

}



// WEBPACK FOOTER //
// ./src/component/shared/layout/header/Header.tsx